document.addEventListener('turbo:load', () => {
  if(document.querySelector('.elements-confirmation-page')) {
    document.querySelector('footer').style = 'margin-top: 0'
    if(document.querySelector('.f1-footer')) {
      document.querySelector('.f1-footer').style = 'margin-top: 0'
    }
  }
})